module.exports = __webpack_public_path__ + "img/al_dhr_logo.cacdde3d.png";